const staff = {
  'pages.platform.user.staff.name': 'Staff Name',
}

export default staff
